import { Nav } from "./nav";
import { Footer } from "./footer";
import { AnnouncementBanner } from "@/components/announcement-banner";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-[100dvh] flex flex-col font-sans">
      <AnnouncementBanner />
      <Nav />
      <main className="flex-1 flex flex-col">
        {children}
      </main>
      <Footer />
    </div>
  );
}
